import DiditSdkDefault, { DiditSdk as DiditSdkNamed } from "@didit-protocol/sdk-web";

/**
 * Open a Didit verification URL the same way the existing KYC page does:
 * the SDK modal on this page first, a full-page redirect if the SDK cannot open.
 *
 * `onFinished` runs when the modal reports completion, so the caller can refresh the status.
 */
export async function openDiditVerification(url, { onFinished } = {}) {
  const themedUrl = withCurrentTheme(url);

  try {
    const DiditSdk = DiditSdkNamed || DiditSdkDefault;
    if (!DiditSdk?.shared?.startVerification) {
      throw new Error("Didit SDK is not available");
    }

    DiditSdk.shared.onComplete = (result) => {
      // The SDK can call this more than once while closing; only react to the first call.
      DiditSdk.shared.onComplete = undefined;
      onFinished?.(result);
    };

    await DiditSdk.shared.startVerification({
      url: themedUrl,
      configuration: {
        zIndex: 100050,
        showCloseButton: true,
        showExitConfirmation: true,
        closeModalOnComplete: false,
        loggingEnabled: process.env.NODE_ENV === "development",
      },
    });
  } catch {
    // Didit sends the browser back to the callback URL (this page) when the hosted flow ends.
    window.location.assign(themedUrl);
  }
}

function withCurrentTheme(url) {
  try {
    const theme = document.body.classList.contains("light_theme") ? "light" : "dark";
    const next = new URL(url);
    next.searchParams.set("theme", theme);
    next.searchParams.set("colorMode", theme);
    return next.toString();
  } catch {
    return url;
  }
}
